import { useThirdParty } from '@/hooks';
import { FONT_FAMILY_PER_LANG } from './constants';
import { ELanguage } from '@/types';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Routing from 'Routing';
import { Toaster } from '@/components/primitives/Toaster';
import clsx from 'clsx';

import './pendo';
import './datadog';

function App() {
  const {
    i18n: { language: currentLang },
  } = useTranslation();
  useThirdParty();
  const location = useLocation();

  // Don't apply min-width constraint on mobile routes
  const isMobileRoute = location.pathname.startsWith('/mobile');

  return (
    <div
      id="app-root"
      className={clsx(
        'relative h-full w-full font-normal',
        !isMobileRoute && 'min-w-[768px] overflow-auto',
        isMobileRoute && 'overflow-hidden',
      )}
      style={{ fontFamily: `${FONT_FAMILY_PER_LANG[currentLang as ELanguage]}` }}
    >
      <Routing />
      <Toaster />
    </div>
  );
}

export default App;
